/*
 *
 * PluginLoader constants
 *
 */

export const SET_PLUGIN_SCHEMA = 'app/PluginLoader/SET_PLUGIN_SCHEMA';
export const GET_PLUGIN_SCHEMA = 'app/PluginLoader/GET_PLUGIN_SCHEMA';
